<app-container>
  <app-header id="header"></app-header>
  <div>
    <div class="galleria-container flex">
      <app-gallery [images]="images()"></app-gallery>
    </div>
    @if (category(); as cat) {
      <h1>{{ cat.name }}</h1>
    }
    <div class="products">
      @for (product of filteredProducts(); track product.id) {
        <app-product-card [product]="product"></app-product-card>
      }
    </div>
    @if (filteredProducts().length > 0) {
      <div class="to-top" (click)="scrollToTop()">terug naar boven</div>
    }
  </div>
</app-container>
